module.exports = __webpack_public_path__ + "static/assets/db93767599eba837a46871720a47d148.png";